import React from 'react';

/**
 * Carte programme — identité + état + gain central (élément visuel).
 */
export default function ProgrammeHeroCard({
  actif,
  onActifChange,
  gainHeadline,
  exemple = '',
}) {
  return (
    <section
      className="rounded-2xl border border-gray-200 bg-white p-4 sm:p-5 shadow-sm"
      data-testid="programme-hero-card"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3 min-w-0">
          <span
            className="mt-0.5 inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-purple-100 text-[#4A148C] text-lg font-bold"
            aria-hidden
          >
            ★
          </span>
          <div className="min-w-0">
            <h2 className="text-lg sm:text-xl font-bold text-gray-900 leading-tight">
              Programme de fidélité
            </h2>
            <p className="text-sm text-gray-600 mt-1 leading-snug">
              Vos clients cumulent des points et les échangent contre vos récompenses.
            </p>
          </div>
        </div>
        <label className="flex items-center cursor-pointer shrink-0">
          <div className="relative">
            <input
              type="checkbox"
              checked={actif}
              onChange={(e) => onActifChange?.(e.target.checked)}
              className="sr-only"
              aria-label={actif ? 'Programme actif' : 'Programme en pause'}
            />
            <div
              className={`block w-12 h-7 rounded-full transition ${
                actif ? 'bg-green-500' : 'bg-gray-300'
              }`}
            />
            <div
              className={`absolute left-0.5 top-0.5 bg-white w-6 h-6 rounded-full transition ${
                actif ? 'translate-x-5' : ''
              }`}
            />
          </div>
          <span
            className={`ml-2 text-xs font-semibold ${
              actif ? 'text-green-700' : 'text-gray-500'
            }`}
          >
            {actif ? 'Actif' : 'En pause'}
          </span>
        </label>
      </div>

      <div
        className="mt-4 rounded-2xl bg-gradient-to-br from-purple-50 to-white border border-purple-100 px-4 py-4 text-center"
        data-testid="programme-gain-highlight"
      >
        <p className="text-[11px] font-semibold uppercase tracking-wide text-[#4A148C]/70 mb-1.5">
          Gain de points
        </p>
        <p className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight leading-tight">
          {gainHeadline}
        </p>
        {exemple ? (
          <p className="mt-2 text-sm text-gray-500">{exemple}</p>
        ) : (
          <p className="mt-2 text-sm text-gray-500">
            Les points sont valables uniquement dans votre boutique.
          </p>
        )}
      </div>
    </section>
  );
}
